import { schema } from "normalizr";
import { DashboardWidgetArraySchema } from "./dashboard-widget";

const DashboardSchema = new schema.Entity("dashboards", {
  dashboardWidgets: DashboardWidgetArraySchema,
});

const DashboardArraySchema = new schema.Array(DashboardSchema);

export { DashboardSchema, DashboardArraySchema };